import { Link, useLocation } from "react-router-dom";
import { BookOpen, LayoutGrid, LogIn, Library, Shield, ShoppingBag, UserCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

function resolveLibraryHref(user) {
  if (!user) return "/library";
  if (user.role === "admin") return "/mobile/admin";
  if (user.role === "partner") return "/mobile/partner";
  return "/mobile/buyer";
}

function resolveAccountHref(user) {
  if (!user) return "/login";
  if (user.role === "admin") return "/dashboard";
  return "/profile";
}

function resolveAccountLabel(user) {
  if (!user) return "Connexion";
  if (user.role === "admin") return "Admin";
  if (user.role === "partner") return "Compte";
  return "Profil";
}

function resolveAccountIcon(user) {
  if (!user) return LogIn;
  if (user.role === "admin") return LayoutGrid;
  if (user.role === "partner") return Shield;
  return UserCircle2;
}

export default function MobileBottomNav({ user }) {
  const location = useLocation();
  const libraryHref = resolveLibraryHref(user);
  const accountHref = resolveAccountHref(user);
  const AccountIcon = resolveAccountIcon(user);
  const libraryActive = location.pathname.startsWith("/library") || location.pathname.startsWith("/mobile");
  const catalogueActive = location.pathname.startsWith("/public/catalogue");
  const accountActive = location.pathname.startsWith(accountHref);

  return (
    <nav className="sticky bottom-3 z-40 mx-auto mt-8 w-full max-w-6xl px-4 pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-3 gap-2 rounded-3xl border border-[#E6E4E0] bg-white p-2 shadow-lg shadow-black/5">
        <NavItem href={libraryHref} icon={Library} label="Bibliothèque" active={libraryActive} />
        <NavItem href="/public/catalogue" icon={BookOpen} label="Catalogue" active={catalogueActive} />
        <NavItem href={accountHref} icon={AccountIcon} label={resolveAccountLabel(user)} active={accountActive} />
      </div>
    </nav>
  );
}

function NavItem({ href, icon: Icon, label, active }) {
  return (
    <Link
      to={href}
      className={cn(
        "flex flex-col items-center justify-center gap-1 rounded-2xl px-3 py-2 text-xs font-semibold transition",
        active ? "bg-[#2A4B46] text-white" : "text-[#5C625F] hover:bg-[#F3EFE9]"
      )}
    >
      <Icon size={18} />
      <span>{label}</span>
    </Link>
  );
}
